export const colors = {
  black: '#000',
  white: '#ffffff',
  gray: {
    98: '#FAFAFA',
    red: '#F8F8F8',
  },
  cyan: {
    web: '#0098eb',
    a11y: '#007bbd',
    ramboll: '#009df0',
    10: '#e5f5fe',
    20: '#ccebfc',
  },
  ocean: {
    base: '#05326e',
    10: '#e6eaf0',
    20: '#cdd6e2',
  },
  forest: {
    base: '#125a40',
    10: '#e7eeec',
    20: '#d0ded9',
  },
  mountain: {
    base: '#273943',
    10: '#e9ebec',
    20: '#d4d7d9',
    40: '#a9b0b4',
    60: '#7d888e',
    80: '#526169',
    get lowAlpha() {
      return `${this.base}4D`;
    },
  },
  pebble: {
    base: '#e3e1d8',
    10: '#fcfcfb',
    20: '#f9f9f7',
    40: '#f3f1ed',
    60: '#eeede8',
    80: '#e9e7e0',
  },
  field: '#FF8855',
};

export const spacing = {
  space: {
    '3xs': '5px',
    xxs: '10px',
    xs: '20px',
    s: '25px',
    m: '40px',
    l: '50px',
    lr: '50px',
    xl: '80px',
    xxl: '120px',
    desktop: {
      xxs: '10px',
      xs: '20px',
      s: '25px',
      ms: '30px',
      m: '40px',
      l: '50px',
      xl: '80px',
      xxl: '120px',
    },
    mobile: {
      s: '10px',
      m: '20px',
      ml: '30px',
      l: '40px',
      xl: '60px',
      xxl: '80px',
    },
  },
};

export const fonts = {
  heading: `'Nunito', sans-serif`,
  body: `'Nunito', sans-serif`,
  book: `'Nunito', sans-serif`,
};

export const textStyles = {
  mobile: {
    campaign: {
      h1: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontSize: '60px',
        lineHeight: '64px',
      },
      h1_thin: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontSize: '60px',
        lineHeight: '64px',
      },
    },
    poland_office: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '-0.04em',
    },
    h1: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '48px',
      lineHeight: '50px',
    },
    poland_h1: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: '300',
      fontSize: '48px',
      lineHeight: '50px',
    },
    h2: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 325,
      fontSize: '34px',
      lineHeight: '38px',
    },
    h2_thick: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '34px',
      lineHeight: '38px',
    },
    poland_h2: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 325,
      fontSize: '34px',
      lineHeight: '38px',
    },
    h3: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 350,
      fontSize: '28px',
      lineHeight: '33px',
    },
    poland_h3: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 350,
      fontSize: '28px',
      lineHeight: '33px',
    },
    h4: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '29px',
    },
    h4_thick: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 550,
      fontSize: '24px',
      lineHeight: '29px',
    },
    poland_h4: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '29px',
    },
    h5: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '21px',
      lineHeight: '26px',
    },
    h5_quote: {
      fontFamily: 'Nunito',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: '21px',
      lineHeight: '24px',
    },
    h5_thick: {
      //special thick h5 for TEXT MODULE
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '21px',
      lineHeight: '26px',
    },
    poland_h5: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '21px',
      lineHeight: '26px',
    },
    poland_h5_thick: {
      //special thick h5 for TEXT MODULE
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '21px',
      lineHeight: '26px',
    },
    h6: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '21px',
      lineHeight: '26px',
    },
    poland_h6: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '21px',
      lineHeight: '26px',
    },
    s: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '10px',
      lineHeight: '13px',
      letterSpacing: '0.01em',
    },
    body: {
      l: {
        //mobile body-large
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '18px',
        lineHeight: '22px',
      },
      s: {
        //mobile body
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '15px',
        lineHeight: '20px',
      },
      s_gcontact: {
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '15px',
        lineHeight: '20px',
      },
      s_g_contact: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '12px',
        lineHeight: '16px',
      },
      xs: {
        //mobile body-small
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '16px',
      },
      xxs: {
        //mobile body-extra-small
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '10px',
        lineHeight: '13px',
      },
      medium: {
        l: {
          //mobile body-large-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '18px',
          lineHeight: '22px',
          letterSpacing: '0.01em',
        },
        s: {
          //mobile body-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '15px',
          lineHeight: '20px',
          letterSpacing: '0.01em',
        },
        s_gcontact: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '15px',
          lineHeight: '20px',
          letterSpacing: '0.01em',
        },
        xs: {
          //mobile body-small-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '12px',
          lineHeight: '16px',
          letterSpacing: '0.02em',
        },
      },
    },
    button: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 680,
      fontSize: '16px',
      lineHeight: '16px',
      letterSpacing: '0.02em',
    },
    contact_poland: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '-0.02em',
    },
    formatted_polska: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 325,
      fontSize: '16px',
      lineHeight: '24px',
    },
    link: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 680,
      fontSize: '15px',
      lineHeight: '20px',
      letterSpacing: '0.01em',
    },
  },
  tablet: {
    h1: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: '64px',
      lineHeight: '72px',
    },
    h2: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 325,
      // WAS 60
      fontSize: '48px',
      lineHeight: '52px',
    },
    h3: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 350,
      fontSize: '36px',
      lineHeight: '40px',
    },
    h4: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '32px',
      lineHeight: '38px',
    },
    h5: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '29px',
    },
    h5_thick: {
      //special thick h5 for TEXT MODULE
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '29px',
    },
    h6: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '29px',
    },
    small: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '11px',
      lineHeight: '14px',
      letterSpacing: '0.01em',
    },
    body: {
      l: {
        //tablet body-large
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '20px',
        lineHeight: '26px',
      },
      s: {
        //tablet body
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '16px',
        lineHeight: '22px',
      },
      xs: {
        //tablet body-small
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0',
      },
      medium: {
        l: {
          //tablet body-large-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '20px',
          lineHeight: '26px',
          letterSpacing: '0.01em',
        },
        s: {
          //tablet body-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '16px',
          lineHeight: '22px',
          letterSpacing: '0.01em',
        },
        xs: {
          //tablet body-small-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '13px',
          lineHeight: '17px',
          letterSpacing: '0.02em',
        },
      },
    },
    button: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 680,
      fontSize: '16px',
      lineHeight: '16px',
      letterSpacing: '0.02em',
    },
  },
  desktop: {
    // TODO: TEMPORARY REMOVE THIS
    campaign: {
      h2: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        // TODO: CRITICAL!! TEMP SOLUTION (should be 400)
        fontSize: '80px',
        lineHeight: '80px',
        letterSpacing: '-0.04em',
      },
      h2_thin: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        // TODO: CRITICAL!! TEMP SOLUTION (should be 400)
        fontSize: '80px',
        lineHeight: '80px',
        letterSpacing: '-0.04em',
      },
      h3: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '60px',
        lineHeight: '68px',
        letterSpacing: '-0.04em',
      },
      h3_thick: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '60px',
        lineHeight: '68px',
        letterSpacing: '-0.04em',
      },
      h5: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 325,
        fontSize: '30px',
        lineHeight: '32px',
        letterSpacing: '-0.04em',
      },
      h5_thick: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 325,
        fontSize: '30px',
        lineHeight: '32px',
        letterSpacing: '-0.04em',
      },
    },
    poland_office: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '-0.04em',
    },
    contact_poland: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '-0.02em',
    },
    format_poland: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '28px',
      letterSpacing: '-0.04em',
    },
    h1: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: '80px',
      lineHeight: '80px',
      letterSpacing: '0px',
    },
    poland_h1: {
      fontFamily: 'Nunito, Helvetica Neue, Helvetica, Arial, sans-serif',
      fontStyle: 'normal',
      fontWeight: 300,
      fontSize: '120px',
      lineHeight: '120px',
      letterSpacing: '-0.04em',
    },
    h2: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 325,
      fontSize: '64px',
      lineHeight: '64px',
      letterSpacing: '0px',
    },
    h2_thick: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '64px',
      lineHeight: '64px',
      letterSpacing: '0px',
    },
    poland_h2: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 325,
      fontSize: '64px',
      lineHeight: '64px',
      letterSpacing: '0px',
    },
    h3: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 350,
      fontSize: '48px',
      lineHeight: '52px',
      letterSpacing: '0px',
    },
    h3_gcontact: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 350,
      fontSize: '48px',
      lineHeight: '52px',
      letterSpacing: '0px',
    },

    poland_h3: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 350,
      fontSize: '48px',
      lineHeight: '52px',
      letterSpacing: '0px',
    },
    h4: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '36px',
      lineHeight: '42px',
      letterSpacing: '0px',
    },
    h4_thick: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 550,
      fontSize: '36px',
      lineHeight: '42px',
      letterSpacing: '0px',
    },
    poland_h4: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '36px',
      lineHeight: '42px',
      letterSpacing: '0px',
    },
    h5: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    h5_quote: {
      fontFamily: 'Nunito',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    h5_thick: {
      //special thick h5 for TEXT MODULE
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    poland_h5: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    poland_h5_thick: {
      //special thick h5 for TEXT MODULE
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    h6: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    poland_h6: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '30px',
      letterSpacing: '0px',
    },
    s: {
      //desktop-small
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '15px',
      letterSpacing: '0.01em',
    },
    body: {
      //desktop body-large
      l: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '24px',
        lineHeight: '30px',
      },
      l_gcontact: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '24px',
        lineHeight: '30px',
      },
      formatted_polska: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: '24px',
        lineHeight: '30px',
      },
      s: {
        //desktop body
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '18px',
        lineHeight: '25px',
      },
      nav_s: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
      },
      nav_s_light: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 325,
        fontSize: '16px',
        lineHeight: '24px',
      },
      s_gcontact: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 350,
        fontSize: '18px',
        lineHeight: '25px',
      },
      xs: {
        //desktop body-small
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '18px',
      },
      medium: {
        l: {
          //desktop body-large-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 650,
          fontSize: '24px',
          lineHeight: '30px',
          letterSpacing: '0.01em',
        },
        l_gcontact: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 650,
          fontSize: '24px',
          lineHeight: '30px',
        },
        s: {
          //desktop body-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '18px',
          lineHeight: '25px',
          letterSpacing: '0.01em',
        },
        xs: {
          //desktop body-small-strong
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '14px',
          lineHeight: '18px',
          letterSpacing: '0.02em',
        },
        s_gcontact: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 680,
          fontSize: '18px',
          lineHeight: '25px',
        },
      },
      book: {
        // "BOOK" STYLE IS REDUNDANT...TO BE REMOVED IN 2026
        l: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '20px',
          lineHeight: '28px',
          letterSpacing: '-0.02em',
        },

        s: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 325,
          fontSize: '16px',
          lineHeight: '20px',
        },
        s24: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 325,
          fontSize: '16px',
          lineHeight: '24px',
        },
        xs: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 325,
          fontSize: '14px',
          lineHeight: '20px',
        },
        xxs: {
          fontFamily: 'Nunito',
          fontStyle: 'normal',
          fontWeight: 325,
          fontSize: '12px',
          lineHeight: '20px',
        },
      },
    },
    button: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 680,
      fontSize: '16px',
      lineHeight: '16px',
      letterSpacing: '0.02em',
    },
    link: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 680,
      fontSize: '18px',
      lineHeight: '25px',
    },
  },
};

export const breakpoints = {
  sm: '640px',
  md: '768px',
  '1md': '820px',
  '2md': '900px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1440px',
  '3xl': '1920px',
};

export const moduleMaxWidth = '1920px';
